import { render } from "./TrendList.vue?vue&type=template&id=21e59379"
import script from "./TrendList.vue?vue&type=script&lang=js"
export * from "./TrendList.vue?vue&type=script&lang=js"

import "./TrendList.vue?vue&type=style&index=0&id=21e59379&lang=css"

import exportComponent from "/Users/hamzaassif/Work/detect-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__